import React from 'react'
import { Center, Stack, Title } from '@mantine/core'

/**
 * Renders a 404 message.
 * @param {string} [width] The width of the container.
 * @param {string} [height] The height of the container.
 * @param {string} [title] The title of the component.
 * @param {string} [message] The message to display under the title.
 * @returns {JSX.Element}
 */
function NotFound ({ width = '100wv', height = '100vh', title = '404', message = 'Not Found' }) {
  return (
    <Center w={width} h={height}>
      <Stack align='center' justify='center'>
        {title.length > 0 && <Title>{title}</Title>}
        <Title order={2}>{message}</Title>
      </Stack>
    </Center>
  )
}

export default React.memo(NotFound)
